import Icon from '../components/Icon.vue'

Icon.register({
  'cloud-moon-rain': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M350.5 225.5C343.6 188.3 311.2 160 272 160 259.7 160 248.1 163 237.7 168 220.3 143.9 192.1 128 160 128 107 128 64 171 64 224 64 224.5 64.2 225.1 64.2 225.6 27.6 232.9 0 265.2 0 304 0 348.2 35.8 384 80 384H336C380.2 384 416 348.2 416 304 416 264.8 387.8 232.3 350.5 225.5zM567.9 223.8C497.5 237.1 432.9 183.5 432.9 113 432.9 72.4 454.8 35 490.4 14.9 495.9 11.8 494.5 3.5 488.3 2.4 479.6 0.8 470.7 0 461.8 0 383.9 0 320.7 61.2 317.4 137.9 344.1 149.8 365.6 171.7 376.3 199.6 413.4 213.9 440.3 247 446.5 286.4 451.6 286.9 456.5 287.9 461.7 287.9 506.4 287.9 547.3 267.7 574.3 234.6 578.5 229.8 574.1 222.6 567.9 223.8zM364.5 418.1C356.9 413.8 347.1 416.3 342.7 424.1L306.1 488.1C301.7 495.8 304.4 505.5 312.1 509.9 314.6 511.3 317.3 512 320 512 325.5 512 330.9 509.1 333.9 503.9L370.5 439.9C374.8 432.2 372.2 422.5 364.5 418.1zM268.5 418.1C260.9 413.8 251.1 416.3 246.7 424.1L210.1 488.1C205.7 495.8 208.4 505.5 216.1 509.9 218.6 511.3 221.3 512 224 512 229.5 512 234.9 509.1 237.9 503.9L274.5 439.9C278.8 432.2 276.2 422.5 268.5 418.1zM172.5 418.1C164.9 413.8 155.1 416.3 150.7 424.1L114.1 488.1C109.7 495.8 112.4 505.5 120.1 509.9 122.6 511.3 125.3 512 128 512 133.5 512 138.9 509.1 141.9 503.9L178.5 439.9C182.8 432.2 180.2 422.5 172.5 418.1zM76.5 418.1C68.9 413.8 59.1 416.3 54.7 424.1L18.1 488.1C13.7 495.8 16.4 505.5 24.1 509.9 26.6 511.3 29.3 512 32 512 37.5 512 42.9 509.1 45.9 503.9L82.5 439.9C86.8 432.2 84.2 422.5 76.5 418.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cloud-moon-rain.js
// module id = i0aD
// module chunks = 144